import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ApiService } from '../../../utils/services/api.service';
import { CURRENCIES, passwordValidator } from '../../../utils/constants/constants';
import { Router } from '@angular/router';
import { NotificationsService } from 'angular2-notifications';
import { passwordMatchValidator } from '../../../utils/validators/custom-validators';

@Component({
  selector: 'app-organization-add',
  templateUrl: './organization-add.component.html',
  styleUrls: ['./organization-add.component.css']
})
export class OrganizationAddComponent implements OnInit {

  public signUpForm: FormGroup;
  public organizationParameterForm: FormGroup;
  public addressForm: FormGroup;
  public isShowUseCompanyPriceVisible = false;
  public isShowUseCompanyPriceExtraHotelVisible = false;
  public formList: Array<FormGroup>;
  public formIndex = 0;
  public isDone = false;
  public currencies = CURRENCIES;
  public paymentGateways = [];
  public isPaymentGateWayVisible = false;
  public organization = {};
  public selectedAgencyProviders = null;
  public providerListConfig = {
    displayKey: "context", //if objects array passed which key to be displayed defaults to description
    search: true,//true/false for the search functionlity defaults to false,
    placeholder: 'Select Providers', // text to be displayed when no item is selected defaults to Select,
    limitTo: 0, // number thats limits the no of options displayed in the UI (if zero, options will not be limited)
    moreText: 'more', // text to be displayed whenmore than one items are selected like Option 1 + 5 more
    noResultsFound: 'No results found!', // text to be displayed when no items are found while searching
    searchPlaceholder: 'Search', // label thats displayed in search input,
    searchOnKey: 'context', // key on which search should be performed this will be selective search. if undefined this will be extensive search on all keys
  }

  constructor(private apiService: ApiService,
    private router: Router,
    private notificationsService: NotificationsService) {
  }
  requestProvider=[{
    "context":"bizitransfer",
    "type":"RequestProvider"
  },
  {
    "context":"bizicar",
    "type":"RequestProvider"
  },
  {
    "context":"bizimeeting",
    "type":"RequestProvider"
  },
  {
    "context":"biziinsurance",
    "type":"RequestProvider"
  }
]

  ngOnInit() {

    this.formList = [];

    this.signUpForm = new FormGroup({
      'organizationName': new FormControl(null, Validators.required),
      'legalEntity': new FormControl(null),
      'firstName': new FormControl(null, Validators.required),
      'lastName': new FormControl(null, Validators.required),
      'username': new FormControl(null, [Validators.required, Validators.email]),
      'password': new FormControl(null, [Validators.required, Validators.minLength(8), passwordValidator()]),
      'passwordControl': new FormControl(null, [Validators.required, Validators.minLength(8)]),
      'language': new FormControl('tr', [Validators.required]),
      'phoneCode': new FormControl(null, [Validators.required]),
      'phoneType': new FormControl(null, [Validators.required]),
      'phoneNumber': new FormControl(null, [Validators.required])
    });
    this.addressForm = new FormGroup({
      'address1': new FormControl(null, Validators.required),
      'address2': new FormControl(null),
      'billingAccountingNumber': new FormControl(null),
      'city': new FormControl(null, [Validators.required]),
      'countryId': new FormControl('TR', [Validators.required]),
      'faxCode': new FormControl(null),
      'faxNumber': new FormControl(null),
      'name': new FormControl(null, [Validators.required]),
      'onlineTradeRegisterNo': new FormControl(null),
      'phoneCode': new FormControl(null),
      'phoneNumber': new FormControl(null, [Validators.required]),
      'street': new FormControl(null, [Validators.required]),
      'taxAdministrationNo': new FormControl(null, [Validators.required]),
      'taxNo': new FormControl(null, [Validators.required]),
      'tradeRegisterNo': new FormControl(null),
      'type': new FormControl(null),
      'zipcode': new FormControl(null, [Validators.required]),
    });

    this.organizationParameterForm = new FormGroup({
      'domesticMaxStop': new FormControl(null, Validators.required),
      'domesticTimeWindow': new FormControl(null, Validators.required),
      'internationalMaxStop': new FormControl(null, Validators.required),
      'internationalTimeWindow': new FormControl(null, Validators.required),
      //'policyReasonCode': new FormControl(null, Validators.required),
      //'justificationReasonCode': new FormControl(null, Validators.required),
      'currency': new FormControl(null, Validators.required),
      'depositAmount': new FormControl(null, Validators.required),
      'costCenterName': new FormControl(null, Validators.required),
      'costCenterCode': new FormControl(null, Validators.required),
      'granteeOrganizationId': new FormControl(null, Validators.required),
      'providers': new FormControl(null),
      'showUseCompanyPrice': new FormControl(),
      'showUseCompanyPriceExtraHotel': new FormControl(),
      'paymentTypeOnAccount': new FormControl(false),
      'paymentTypeCreditCard': new FormControl(false),
      'paymentGateWay': new FormControl(null),
      'cabinTypeEconomy': new FormControl(false),
      'cabinTypeBusiness': new FormControl(false),
    });

    this.formList.push(this.signUpForm);
    this.formList.push(this.organizationParameterForm);
    this.formList.push(this.addressForm);

    this.organizationParameterForm.controls.granteeOrganizationId.valueChanges.subscribe(res => {
      this.selectedAgencyProviders = null;
      if (res) {
        this.apiService.getOrganizationProviders(res, 'type_Eq=PaymentGateway').subscribe(gatewayRes => {
          this.paymentGateways = (gatewayRes.data || []).map(item => item.context);
          this.organizationParameterForm.controls.paymentGateWay.patchValue(
            this.paymentGateways.length === 1 ? this.paymentGateways[0] : null);
        }, err => {
          this.paymentGateways = [];
          this.organizationParameterForm.controls.paymentGateWay.patchValue(null);
        });

        this.apiService.getOrganizationProviders(res, 'type_In=FlightProvider,HotelProvider,PackageProvider,RequestProvider').subscribe(providerRes => {
          this.selectedAgencyProviders = providerRes.data;
         this.requestProvider.forEach(data=>{
          this.selectedAgencyProviders.push(data)
        })
        }, err => {
          this.selectedAgencyProviders = [];
        });
        
      } else {
        this.selectedAgencyProviders = null;
        this.paymentGateways = [];
        this.organizationParameterForm.controls.paymentGateWay.patchValue(null);
      }
      
    });
    this.organizationParameterForm.controls.paymentTypeCreditCard.valueChanges.subscribe(
      (value) => {
        this.isPaymentGateWayVisible = value;
      }
    );
    this.organizationParameterForm.controls.providers.valueChanges.subscribe(res => {
      if (res) {
        let checkBiziHotel = res.find(item => item.context == 'bizihotel');
        let checkExtraHotel = res.find(item => item.context == 'extrahotel');
        if (checkBiziHotel) {
          this.isShowUseCompanyPriceVisible = true;
        }
        if (checkExtraHotel) {
          this.isShowUseCompanyPriceExtraHotelVisible = true;
        }
        if (!checkBiziHotel) {
          this.isShowUseCompanyPriceVisible = false;
        }
        if(!checkExtraHotel){

          this.isShowUseCompanyPriceExtraHotelVisible = false;
        }
      }
    })
  }

  onNextClicked() {
    if (this.formIndex == 1 && !this.organizationParameterForm.value.paymentTypeOnAccount && !this.organizationParameterForm.value.paymentTypeCreditCard) {
      this.notificationsService.warn('Please select a payment type!');
      return;
    }
    if (this.formIndex === 1 && this.organizationParameterForm.value.paymentTypeCreditCard
      && !this.organizationParameterForm.value.paymentGateWay) {
      this.notificationsService.warn('Please select a payment gateway defined on the selected agency!');
      return;
    }
    if (this.formIndex >= this.formList.length - 1) {
      this.formIndex = this.formList.length - 1;
      this.isDone = true;
      this.organization['name'] = this.signUpForm.controls.organizationName.value;
      this.organization['legalEntity'] = this.signUpForm.controls.legalEntity.value;
      this.organization['firstName'] = this.signUpForm.controls.firstName.value;
      this.organization['lastName'] = this.signUpForm.controls.lastName.value;
      this.organization['username'] = this.signUpForm.controls.username.value;
      this.organization['password'] = this.signUpForm.controls.password.value;
      this.organization['twoFactorType'] = false;
      this.organization['phone'] = {
        type: this.signUpForm.value.phoneType,
        phoneCode: this.signUpForm.value.phoneCode,
        number: this.signUpForm.value.phoneNumber,
        isPrimary: true
      }
      this.organization['profile'] = {
        'language': this.signUpForm.controls.language.value
      }
      this.organization['address'] = {
        address1: this.addressForm.value.address1,
        address2: this.addressForm.value.address2,
        billingAccountingNumber: this.addressForm.value.billingAccountingNumber,
        city: this.addressForm.value.city,
        countryId: this.addressForm.value.countryId,
        faxCode: this.addressForm.value.faxCode,
        faxNumber: this.addressForm.value.faxNumber,
        name: this.addressForm.value.name,
        onlineTradeRegisterNo: this.addressForm.value.onlineTradeRegisterNo,
        phoneCode: this.addressForm.value.phoneCode,
        phoneNumber: this.addressForm.value.phoneNumber,
        street: this.addressForm.value.street,
        taxAdministrationNo: this.addressForm.value.taxAdministrationNo,
        taxNo: this.addressForm.value.taxNo,
        tradeRegisterNo: this.addressForm.value.tradeRegisterNo,
        type: 'Main',
        zipcode: this.addressForm.value.zipcode,
      }

      this.organization['maxStopsDomestic'] = this.organizationParameterForm.controls.domesticMaxStop.value;
      this.organization['timeWindowDomestic'] = this.organizationParameterForm.controls.domesticTimeWindow.value;
      this.organization['maxStopsInternational'] = this.organizationParameterForm.controls.internationalMaxStop.value;
      this.organization['timeWindowInternational'] = this.organizationParameterForm.controls.internationalTimeWindow.value;
      //this.organization['policyReasonCode'] = this.organizationParameterForm.controls.policyReasonCode.value;
      //this.organization['justificationReasonCode'] = this.organizationParameterForm.controls.justificationReasonCode.value;
      this.organization['currency'] = this.organizationParameterForm.controls.currency.value;
      this.organization['depositAmount'] = this.organizationParameterForm.controls.depositAmount.value;
      this.organization['costCenterName'] = this.organizationParameterForm.controls.costCenterName.value;
      this.organization['costCenterCode'] = this.organizationParameterForm.controls.costCenterCode.value;

      this.organization['onAccount'] = this.organizationParameterForm.controls.paymentTypeOnAccount.value ? 'OnAccount' : null;
      this.organization['creditCard'] = this.organizationParameterForm.controls.paymentTypeCreditCard.value ? 'CreditCard' : null;

      this.organization['flightCabinClasses'] = [{
        value: this.organizationParameterForm.controls.cabinTypeBusiness.value,
        context: 'Business'
      },
      {
        value: this.organizationParameterForm.controls.cabinTypeEconomy.value,
        context: 'Economy'
      }
      ]
      this.organization['defaultPaymentGateway'] = this.organizationParameterForm.controls.paymentGateWay.value;
      this.organization['granteeOrganizationId'] = this.organizationParameterForm.controls.granteeOrganizationId.value;
      if (this.organizationParameterForm.controls.granteeOrganizationId.value) {
        let providerContexts = {
          'HotelProvider': 'Hotel',
          'FlightProvider': 'Flight',
          'PackageProvider': 'Package',
          'RequestProvider': 'TravelRequest',
        }
        this.organization['providers'] = [];
        let selectedProviders = this.organizationParameterForm.controls.providers.value || [];
        this.organization['providers'] = selectedProviders.map(item => {
          return {
            key: 'Provider',
            context: providerContexts[item.type],
            value: item.context
          }
        });
        let checkBiziHotel = selectedProviders.find(item => item.context == 'bizihotel');
        let checkExtraHotel = selectedProviders.find(item => item.context == 'extrahotel');

        if (checkBiziHotel) {
          this.organization['providers'].push({
            context: 'Hotel',
            key: 'ShowUseCompanyPrice',
            value: this.organizationParameterForm.value.showUseCompanyPrice || false
          });
        }
        if (checkExtraHotel) {
          this.organization['providers'].push({
            context: 'Hotel',
            key: 'ShowUseCompanyPriceExtraHotel',
            value: this.organizationParameterForm.value.showUseCompanyPriceExtraHotel || false
          });
        }
      } else {
        delete this.organization['providers'];
      }

    } else {
      this.formIndex++;
      this.isDone = false;
    }
  }

  onPreviousClicked() {
    this.isDone = false;
    if (this.formIndex <= 0) {
      this.formIndex = 0;
    } else {
      this.formIndex--;
    }
  }

  saveOrganizations() {

    this.apiService.createOrganization(this.organization).subscribe(
      response => {
        this.notificationsService.success('Success', 'Organization is created');
        this.router.navigate(['admin/organizations']);
      }, error => {
        this.notificationsService.error('Error', 'Error occured');
      }
    );
  }

}



// WEBPACK FOOTER //
// /var/www/bizisystem-frontend/src/src/app/main/pages/organization-add/organization-add.component.ts